/**
 * Created by wuchao on 2018/3/2.
 */
export function resizeBaseDiv () {
  var height = window.innerHeight;
  $(".weui-tab__panel").css("padding-bottom","0");
  $(".weui-tab__panel").css("overflow","hidden");
  $(".weui-tab").parent().css("height",height);
}



// WEBPACK FOOTER //
// ./src/js/common/resize.js